export enum DriverTabPanelEnum {
  All = 'All',
  Active = 'Active',
  Inactive = 'Inactive',
}
